<template>
    <div class="private-and-policy">
        <div class="private-and-policy-wrap">
            <div class="container">
                <div class="title-block">
                    <h1>企業會員條款</h1>
                    <span class="update-date">更新於 2021 - 02 - 18</span>
                    <div class="description">
                        親愛的企業使用者您好，歡迎您使用本平台，當您申請註冊企業會員通過後，即可正式使用本平台企業會員服務，為保障您的權益，請您詳細閱讀、理解並同意遵守下列「企業會員條款」所有內容。
                    </div>
                </div>
                <div class="content-block">
                    <h2>認識與同意企業會員服務條款</h2>
                    <ul class="list">
                        <li>
                            1. 本平台企業會員服務（以下簡稱「本服務」）係由方居浩斯科技股份有限公司（以下簡稱「本公司」）所建置提供，提供企業會員於本平台(以下或稱「本系統」)使用本服務，所有使用本服務的使用者(以下稱企業會員)，都應該詳細閱讀下列約定條款。當您完成企業會員(含企業會員帳號與員工帳號)註冊、或開始使用本服務時，即表示您已詳細閱讀、瞭解並同意接受本服務條款之所有內容。
                        </li>
                        <li>
                            2. 本服務條款訂立的目的，是為了保護本服務的提供者以及所有企業會員的權益，並與企業會員之間成立服務契約，公告內容與系統內說明亦為本條款之一部分。本公司有權隨時就本服務條款之內容進行修改或變更，並得以於本系統服務公告之，不再個別通知企業會員，建議您隨時注意本服務條款之修改、變更與系統服務公告。倘您於服務條款修改、變更或公告後仍繼續使用本服務，即表示您已閱讀、瞭解並同意接受本服務條款之修改或變更。
                        </li>
                        <li>
                            3. 本條款所稱之企業會員，除性質不相容外均兼指員工帳號會員。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>企業會員註冊注意事項</h2>
                    <span class="description">為確保交易安全與您的權益，請您同意以下註冊相關事項</span>
                    <ul class="list">
                        <li>
                            1. 本服務採用會員制，申請者須填寫電子郵件等其他相關資料及設定密碼以註冊帳號，經電子郵件認證後並進一步登入帳號填寫公司基本資料與提供相關文件電子檔案，包括但不限於公司名稱、統一編號、地址、負責人、證書等相關資訊申請企業認證，最終經本系統審核通過後始得使用本系統提供之各項服務，於本系統審核通過前之帳號僅能進行平台瀏覽。審核通過之帳號仍應盡速填寫帳號其他進階設定以完善相關服務提供，取得更便利之服務。
                        </li>
                        <li>
                            2. 申請者註冊時應填寫正確、最新的資料，不可有提供偽造或變造之資料、進行重複註冊、以他人名義註冊或未經授權註冊等不當情事，並同意本系統於提供本服務必要範圍內得以收集、保存、利用相關資訊或向第三方核實。
                        </li>
                        <li>
                            3. 為保障交易安全與維護企業會員權益，若申請者並非依法登記法人或團體、操作之自然人非經授權或不具有完全行為能力(包括未成年人、受監護宣告或受輔助宣告等)或員工帳號持有者不具有完全行為能力時，本系統有權婉拒您的註冊申請或透過系統停用您的帳號與使用本服務之全部或一部之權限或終止雙方法律關係。
                        </li>
                        <li>
                            4. 為提供企業會員最佳的服務，您保證與聲明填寫之資訊均為正確、最新，如已過時或錯誤應迅速更新或更正該過時或不正確資訊。若您重複註冊、使用他人名義或未經授權註冊、填寫任何錯誤或不實的資料或欠缺必要之資料或未有更新時:
                            <ul>
                                <li>( 1 )	本系統有權拒絕您的註冊、或於不經事先通知您即逕行透過系統暫停您的帳號與使用本服務之全部或一部之權限或終止本條款</li>
                                <li>( 2 )	若造成自身損害您應自行承擔，包括但不限於您因填寫錯誤或未實際使用電子郵件導致未能收到本公司寄發之電子發票或其他電子文件等情事。</li>
                                <li>( 3 )	若造成其他會員或第三人損害，您應自行負擔相應之法律責任，與本系統或本公司無涉。</li>
                                <li>( 4 )	若造成本系統或本公司損害，您應負擔相應之法律責任，本公司將保留相關法律訴追之權利。</li>
                            </ul>
                        </li>
                        <li>
                            5. 您保證確為依法經營不動產與住宅租賃業務之經紀業、包租業者；相關人員資格與配置，亦符合相關主管機關與法規之要求，如有違反概與本平台無涉，企業會員應自行承擔相關法律責任。
                        </li>
                        <li>
                            6. 您保證提供本系統所有相關證明類文件與資訊，包括但不限於不動產仲介經紀商業公會會員證書、不動產經紀人證書、租賃住宅服務業登記證等相關文件均為有權、正確、真實、合法、有效，如有違反概與本平台無涉，如有不符造成他人或本公司受有損害，應負擔相關法律賠償責任。
                        </li>
                        <li>
                            7. 您應自行評估調整使用本系統進行業務執行均符合相關主管機關與法規要求，包括不動產租賃、租屋轉租之所有相關規定(如前提條件、執行流程、配套程序、通知義務、告知義務等)，如因使用本平台或不當使用本平台受有相關法律責任應自行負擔，與本平台無涉。
                        </li>
                        <li>
                            8. 您同意本系統所為之通知均以您申請本服務時所提供之通訊資料為準；相關通訊資料如有變更，您應立即於本系統更新或修改。如您提供之通訊資料為錯誤或未依規定方式更新通訊資料時，本系統依原留存之通訊資料所為之通知均視為已送達。
                        </li>
                        <li>
                            9. 您同意於使用本服務之內容時，任何一方均得以電子資料傳輸之方式為意思表示及以電子文件方式表示、保存，並同意於簽署任何電子文件時，除法定要式文件與法定要式簽署以外，任何足以證明為本人或有權之人之意思表示之方式已足，包括但不限於印文電子檔、簽名電子檔或透過裝置網路簽署之簽名檔案等。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>企業會員服務內容</h2>
                    <ul class="list">
                        <li>
                            1. 您正式註冊成為企業會員後，本公司將依本系統當時所建置的服務、項目、內容、狀態及功能，提供企業會員服務；本公司保留隨時變更服務項目與內容之權利，變更後之服務項目與內容，經公佈於本系統或相關網頁後，不另行個別通知企業會員。
                        </li>
                        <li>
                            2. 目前本服務提供為部分功能收費，詳細收費事項請參考本系統版本公告或本系統版本說明；本公司保留隨時變更免費服務為收費服務、變更收費標準之權利，變更後之內容，經公佈或實裝於本系統或相關網頁後，將不再另行個別通知企業會員。
                        </li>
                        <li>
                            3. 本系統將提供各企業會員一組專屬帳號(帳號名稱同企業會員申請時所使用之電子郵件地址)與密碼(由企業會員自行設定)，主要提供企業會員管理功能、內部權限與其他相關服務，詳細服務內容依使用當時本系統版本內容與說明為主，本系統並保留相關功能變更修改之權利，變更後之內容，經公佈或實裝於本系統或相關網頁後，將不再另行個別通知企業會員。
                        </li>
                        <li>
                            4. 本系統提供企業會員各種管理編輯功能、廣告、財務報表、內部權限等相關第三方電子平台服務，企業會員之操作指示本系統均予以尊重，本系統均為按實依據企業會員操作指示或徵得企業會員同意始進行相關服務提供。
                        </li>
                        <li>
                            5. 租屋契約關係存在於簽約企業會員與房客之間，本系統非租屋當事人、租屋仲介或相關類似身分人員，亦不為任何保證，如房客履行契約等。
                        </li>
                        <li>
                            6. 企業會員主動建立之員工帳號，應經自然人員工以電子郵件認證後始能建立，員工帳號為員工個人所管理保管、設定密碼，但相關權限受建立之企業會員帳號管理或限制，員工帳號視為企業帳號之延伸，隸屬於建立之企業帳號，除性質上不相容外，同受相關企業會員保障與限制。企業會員並應保證員工具有完全行為能力並知悉且確實遵守相關條款，如因員工行為造成其他人或本公司受有損害，企業會員應負相關責任。
                        </li>
                        <li>
                            7. 本系統提供企業會員第三方支付服務，僅於系統功能需求下提供代收代付金融帳號，並將相應代收付款項代為收付保管後根據企業會員要求、約定或系統設定移交企業會員指定或應收取之金融帳號，操作過程企業會員均應確認所有相關資訊(特別是代收付金額、金融帳號)之正確性，如因企業會員操作錯誤或動機錯誤等情事致使自身或第三人受有損害，企業會員應自行承擔風險或法律責任，相關細節流程設定等詳細服務內容依使用當時本系統版本內容與說明為主，本系統並保留相關功能變更修改之權利，變更後之內容，經公佈或實裝於本系統或相關網頁後，將不再另行個別通知企業會員。
                        </li>
                        <li>
                            8. 若企業會員於服務項目、收費模式等內容進行修改、變更或公告後仍繼續使用本服務，視為企業會員已閱讀、瞭解並同意接受本服務條款之修改或變更。
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>企業會員個人資料保護</h2>
                    <ul class="list">
                        <li>
                            1. 關於企業會員所登錄或留存之個人資料、員工資料及其他特定資料(下合稱個人資料)，悉依「隱私權政策」受到保護與規範(請參見本平台「隱私權政策」)。本公司將依據相關規範持續基於營運所需於中華民國(台灣)內為收集、使用與保管，直至您提出停止使用本系統或本系統終止提供服務日為止。
                        </li>
                        <li>
                            2. 本公司將依據相關規範持續保密您提供的個人資料，惟在下列情形，本公司有可能會查看或提供企業會員的個人資料或相關電信資料給相關政府機關、或主張其權利受侵害並提出適當證明之第三人：
                            <ul>
                                <li>( 1 )	依法令規定、或依司法機關或其他相關政府機關的命令；</li>
                                <li>( 2 )	企業會員涉及違反法令、侵害第三人權益、或違反本使用條款或各該使用規範或約定；</li>
                                <li>( 3 )	3.保護企業會員服務系統之安全或經營者之合法權益；</li>
                                <li>( 4 )	為保護其他使用者或其他第三人的合法權益；</li>
                                <li>( 5 )	為維護本系統的正常運作。</li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="content-block">
                    <h2>使用注意事項</h2>
                    <ul class="list">
                        <li>
                            1. 正式註冊成為企業會員後，將取得一組專屬帳號並自行設定密碼，企業會員同意並瞭解維持密碼之機密性，並僅得用於使用本服務，不應揭露、讓與或將其密碼提供予任何第三人，或供第三人有償或無償使用，請企業會員同意以下事項： 
                            <ul>
                                <li>( 1 )	當企業會員依照本系統規定方式正確登入時所進行之一切行動，無論是否由有權人員親自操作，一律視為企業會員有權人員使用操作。</li>
                                <li>( 2 )	企業會員有妥善自行保管密碼和保密的義務，對於登入特定帳號並使用本服務之行為，均由持有該帳號和密碼之企業會員負責。</li>
                                <li>( 3 )	企業會員帳號、密碼及企業會員權益均僅供企業會員使用及持有，不得轉借、轉讓他人或與他人共用，因此致生之損害，企業會員應自行全權負責，與本公司無涉。</li>
                                <li>( 4 )	如企業會員專用帳號有遭盜用、不當使用、不法使用或其他本公司或本系統無法辯識是否為企業會員有權人員親自使用之情況時，因此致生之損害，企業會員應自行全權負責，與本公司無涉。</li>
                                <li>( 5 )	企業會員如果發現或懷疑其帳號恐遭第三人冒用或不當使用，企業會員應立即通知本公司，以利本公司及時採取適當的因應措施；但上述因應措施不得解釋為本公司因此而明示或默示對企業會員負有任何形式之賠償或補償義務。</li>
                            </ul>
                        </li>
                        <li>
                            2. 本平台提供企業會員上傳房源介紹影音內容之服務，若您正式上傳影音內容將視為您已詳細閱讀、理解並同意下列事項:
                            <ul>
                                <li>( 1 )	您同意無償授權本平台得基於研究、廣告等商業活動目的使用您上傳之影音內容；並得為不改變影片目的之適度編輯，所謂編輯包括但不限於剪輯、上浮水印、加入片頭片尾等類似行為，您並同意不對本平台主張著作權人格權。</li>
                                <li>( 2 )	您同意無償授權本平台得基於研究、廣告等商業活動目的再轉授權，且同意本平台得自行將影音內容或編輯後之影音內容上傳至其他平台曝光。</li>
                                <li>( 3 )	您應確保上傳之影音內容須與房源直接相關且無虛偽不實、引人錯誤之虞外；更應無不法內容並符合中華民國相關法律、主管機關命令及行政作業規範等規定，包括但不限於消費者保護法、著作權法、商標法、專利法、公平交易法等相關法規；如有侵犯他人或本平台之權利，您應承擔相關法律責任。</li>
                                <li>( 4 )	若您上傳之影音內容有相關違規情形，本平台將保留進行修改、直接移除影音內容、拒絕提供上傳服務之權利。</li>
                            </ul>
                        </li>
                        <li>
                            3. 企業會員擔保並承諾所編輯刊登之所有訊息均為真實，內容不得有任何虛偽不實或誇大隱匿等不當與不法之處，包括但不限於房源本身、房源狀況、房源介紹等相關資訊之真實性；如企業會員編輯刊登之訊息涉及或有涉及前述不實內容之虞時，除應自行負擔相關法律責任外，本公司將有權為下列處理:
                            <ul>
                                <li>( 1 )	透過系統強制下架企業會員刊登之不實房源資訊，並禁止再行張貼；經下架之房源如於系統下架前有會員下定付款，本平台有權將已收取款項全數退還下定會員。</li>
                                <li>( 2 )	暫時停止您部分或全部企業會員權限。</li>
                                <li>( 3 )	永久停權或註銷企業會員帳號。</li>
                                <li>( 4 )	如因企業會員刊登不實房源資訊造成本公司受有相關損害或損失，本公司保留向企業會員請求賠償全部損害或損失之權利。</li>
                                <li>( 5 )	其他適當之處理。</li>
                            </ul>
                        </li>
                        <li>
                            4.  企業會員理解並同意刊登之房源如經本系統與本公司合理判定屬於異常房源，包括系統錯誤顯示、不實房源等，於有房客會員已為下定或付款時，為保護您與其他會員及本平台的權益並避免紛爭，您同意無條件配合本平台進行退訂退款作業。
                        </li>
                        <li>
                            5. 企業會員聲明並承諾如下事項:
                            <ul>
                                <li>( 1 )	遵守中華民國(台灣)相關法規，絕不為任何非法目的或以任何非法方式使用本服務；若係於中華民國(台灣)以外國家或地區使用，應承諾遵守使用行為所在之國家或地區之法令。</li>
                                <li>( 2 )	保證不會利用本服務從事侵害他人權益、違法或其他不符本服務所提供的使用目的等不當之行為。</li>
                                <li>( 3 )	保證不使用不適當之技術方法操控本服務、干擾本服務之軟硬體系統設備或複製、改造或公開傳輸本公司為提供本服務所使用之軟體、程式、資料庫及應用程式介面，及使用逆向工程、拆解或其他方法以分析上開軟體、程式、資料庫及應用程式介面。</li>
                                <li>( 4 )	保證不從事其他妨礙本服務之正常營運或本公司認為不適當之行為。</li>
                            </ul>
                        </li>
                        <li>
                            6. 本公司保留得依本服務實際執行情形，增加、修改或終止相關部分或全部企業會員服務，並選擇最適方式告知企業會員之權利。企業會員同意發生下列情形之一時，本公司有權可以暫停提供部分或全部本服務：
                            <ul>
                                <li>( 1 )	本系統需進行必要更新、修正與維護時。</li>
                                <li>( 2 )	本系統由於天災等不可抗力之因素或其他不可歸責事由致本公司或本系統無法提供本服務時。</li>
                                <li>( 3 )	本公司裁量認定企業會員使用本服務，已違反法律、本條款或其他要求。</li>
                            </ul>
                        </li>
                        <li>
                            7. 企業會員理解並同意下述對於相關智慧財產權保護之內容:
                            <ul>
                                <li>( 1 )	本系統所有內容，包括但不限於著作、圖片、檔案、資訊、程式設計、介面、URL、商標或標識、資料庫等，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等所有權及權利，均屬於本公司或授權本公司使用之合法權利人所有。任何人不得逕自使用、修改、重製、公開播送、改作、散佈、發行、公開發表、進行還原工程、解編或反向組譯。</li>
                                <li>( 2 )	承上，如有侵害上開權利，應對本公司負相關損害賠償責任；若企業會員有涉及侵權之情事，本公司有權可暫停涉嫌企業會員之全部或部份服務。</li>
                            </ul>
                        </li>
                        <li>
                            8. 企業會員理解並同意致生交易款項之原因事實及其交易關係，僅存在於企業會員與房客方會員間，本系統僅依雙方之指示、同意與委託提供服務。雙方間所涉及債之關係，其權利義務關係僅存在於雙方會員之間，與本公司或本系統無涉。會員使用本系統不代表本系統對於各該交易之履行有任何明示或默示之保證或承諾。
                        </li>
                        <li>
                            9. 企業會員同意若因本服務產生請求或爭議時，以下列方式為處理：
                            <ul>
                                <li>( 1 )	先向本公司為反應與溝通，本公司之目標在於瞭解並回應企業會員之疑慮，並提出中立且具成本效益、得以迅速解決爭議之建議方法。</li>
                                <li>( 2 )	若上開建議方法無法滿足企業會員的需求，企業會員同意因本條款所生或與本條款有關之任何請求或爭議，應以中華民國(台灣)法律為準據法。因本服務條款所發生的訴訟，以台灣台北地方法院為第一審管轄法院。</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    mounted () {
        this.$analytics.logEvent("會員條款", {
            screen_name: "會員條款"
        });
    },
    components: {
        
    }
}

</script>

<style lang="scss" scoped>
    .private-and-policy{
        background-color: #f6f6f6;
        .private-and-policy-wrap{
            padding-top: 75px;
            padding-bottom: 120px;
            position: relative;
            .container {
                width: 911px;
                margin-left: auto;
                margin-right: auto;
                box-sizing: border-box;
            }
            .title-block{
                position: relative;
                margin-bottom: 40px;
                h1{
                    font-size: 36px;
                    margin-bottom: 12px;
                }
                h1:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -26px;
                    height: 3px;
                    width: 60px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .update-date{
                    position: absolute;
                    color: #a8a5a4;
                    top: 10px;
                    right: 0px;
                }
                .description{
                    width: 660px;
                    font-weight: 300;
                    line-height: 1.71;
                }
            }
            .content-block{
                background-color: #ffffff;
                padding: 24px 28px;
                margin-bottom: 24px;
                border-radius: 8px;
                border: solid 1px #f0f0f0;
                h2{
                    font-size: 20px;
                    margin-bottom: 8px;
                }
                .description{
                    color: #a8a5a4;
                    line-height: 1.71;
                }
                .list:before{
                    content: '';
                    position: absolute;
                    display: block;
                    top: -23px;
                    height: 2px;
                    width: 24px;
                    border-radius: 4.5px;
                    background-color: #ff9275;
                }
                .list{
                    position: relative;
                    margin-top: 42px;
                    width: 660px;
                    li{
                        line-height: 1.71;
                        font-weight: 300;
                        margin-bottom: 16px;
                        > ul{
                            position: relative;
                            margin-top: 16px;
                            margin-left: 20px;
                        }
                    }
                    
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .private-and-policy{
            background-color: #f6f6f6;
            .private-and-policy-wrap{
                padding-top: 100px;
                padding-bottom: 40px;
                .container {
                    width: 100%;
                    padding: 0px 20px;
                    margin: unset;
                }
                .title-block{
                    h1{
                        font-size: 28px;
                        margin-bottom: 16px;
                    }
                    .update-date{
                        position: relative;
                        display: block;
                        margin-bottom: 18px;
                        top: 0px;
                    }
                    .description{
                        width: 100%;
                    }
                }
                .content-block{
                    padding: 20px;
                    .list{
                        width: 100%;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/officailPage/policyTerm/bizUserTerms.vue